import { Box, Text, Flex } from "@chakra-ui/layout";
import { getTime } from "helper/helper";
import React from "react";

const RecievedMessage = ({ chats }) => {
  const senderChats = chats.filter(
    (i) => i.username?.split("_").pop() === "recruiter"
  );

  return (
    <div>
      {chats?.map((i) => (
        <div
          style={{
            display: "flex",
            justifyContent:
              i.username?.split("_").pop() === "recruiter"
                ? "flex-start"
                : "flex-end",
          }}
        >
          <Box maxW={"300px"} px={4} py={2} my={1}>
            <Flex
              px={4}
              py={2}
              borderRadius={
                i.username?.split("_").pop() === "recruiter"
                  ? "14px 14px 14px 2px"
                  : "14px 14px 2px 14px"
              }
              bg={
                i.username?.split("_").pop() === "recruiter"
                  ? "#F4F4F4"
                  : "#6C56FB"
              }
            >
              <Text
                wordBreak={"break-all"}
                fontSize={18}
                fontFamily={"Roboto"}
                color={
                  i.username?.split("_").pop() === "recruiter" ? "#000" : "#fff"
                }
              >
                {i?.message}
              </Text>
            </Flex>
            <Text
              fontSize={12}
              textAlign={
                i.username?.split("_").pop() === "recruiter" ? "left" : "right"
              }
            >
              {getTime(i?.timestamp)}
            </Text>
          </Box>
        </div>
      ))}
    </div>
  );
};

export default RecievedMessage;
